module.exports = __webpack_public_path__ + "img/painting.e4507e3d.gif";